import styles from './style.module.scss';
import { ReactComponent as Logo } from '../../../assets/svg/ingame-logo-n.svg';
import { Row, Col, Space } from 'antd';
import getFormatMessage from '../../../locales/get-format-message';
import { getLocaleLanguage, LanguageType } from '../../../lib';
import { getConfig } from '../../../config';
import { IAppLinkConfig } from '../../../model';
import { getLoginToken, jumpToLogin } from '../../lib';
import { BoxFrame } from '../../../components/box-frame';

export const Footer = () => {
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const copyRight = getConfig()?.copyRight;
  const userURL = getConfig()?.userURL;
  const consoleURL = getConfig()?.consoleURL;
  const websiteURL = getConfig()?.websiteURL;
  const { copyRightText, protocolLinks } = copyRight;
  const documentConfig = getConfig()?.documentConfig;
  const ingameModule = documentConfig.modules.find(
    (module) => module.key === 'INGAME'
  );
  const handleDocumentationClick = () => {
    const pid = ingameModule?.pid[currentStoreLanguage];
    const ticket = getLoginToken();
    if (ticket) {
      if (consoleURL && pid) {
        const url = `${consoleURL}/doc/detail/${pid}`;
        window.open(url, '_blank');
      }
    } else {
      jumpToLogin();
    }
  };
  return (
    <BoxFrame className={styles.footerComponent}>
      <Row gutter={[48, 48]}>
        <Col flex={1}>
          <Space align="start" size={128}>
            <dl className={styles.footerListBox}>
              <dt>{getFormatMessage('products')}</dt>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('multiplayer')}
                </a>
              </dd>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('social')}
                </a>
              </dd>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('content_footer')}
                </a>
              </dd>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('economy')}
                </a>
              </dd>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('analytics')}
                </a>
              </dd>
              <dd>
                <a href={`${websiteURL}/#servicesBox`}>
                  {getFormatMessage('engagement')}
                </a>
              </dd>
            </dl>
            <dl className={styles.footerListBox}>
              <dt>{getFormatMessage('resources')}</dt>
              {/* <dd>
                <a href="">{getFormatMessage('roadmap')}</a>
              </dd> */}
              <dd>
                <span onClick={handleDocumentationClick}>
                  {getFormatMessage('docs')}
                </span>
              </dd>
              <dd>
                <a href={`${websiteURL}/roadmap`}>Roadmap</a>
              </dd>
            </dl>
            <dl className={styles.footerListBox}>
              <dt>{getFormatMessage('support')}</dt>
              <dd>
                <a href={`${websiteURL}/get-started`}>
                  {getFormatMessage('get_started_uppercase')}
                </a>
              </dd>
              {/* <dd>
                <a href="">{getFormatMessage('about')}</a>
              </dd> */}
            </dl>
          </Space>
        </Col>
        <Col>
          <Space>
            <dl className={styles.footerListBox}>
              <dt>{getFormatMessage('we_are_online')}</dt>
              <dd>
                <a
                  href={`${userURL}/contact?ingame_language=${currentStoreLanguage}`}
                >
                  {getFormatMessage('contact_us_footer')}
                </a>
              </dd>
              <dd className="list-extra-text">
                <span className="list-disable-click">
                  {getFormatMessage('contact_for_product')}
                </span>
              </dd>
            </dl>
          </Space>
        </Col>
        <Col span={24}>
          <Row gutter={[24, 24]} align="middle">
            <Col>
              <span className={styles.footerLogo}>
                <Logo width={24} height={24} />
              </span>
            </Col>
            <Col>
              <p className={styles.footerCopyRight}>
                {copyRightText}
                <span
                  className={copyRight.filingLink ? styles.link : ''}
                  onClick={() => window.open(copyRight.filingLink, '_blank')}
                >
                  {copyRight.filingCaseNumber}
                </span>
              </p>
            </Col>
            <Col flex={1}>
              <p className={styles.footerEndLink}>
                {protocolLinks[currentStoreLanguage]?.map(
                  (link: IAppLinkConfig) => {
                    let processedUrl = '';
                    if (link.url === '') {
                      processedUrl = '';
                    } else if (link.url.includes('.com')) {
                      processedUrl = link.url;
                    } else {
                      processedUrl = `${consoleURL}${link.url}`;
                    }
                    return (
                      <a href={processedUrl} target="_blank">
                        {link.label}
                      </a>
                    );
                  }
                )}
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </BoxFrame>
  );
};
